 "use client";

import "./coming-soon.css";

export default function ComingSoonPage() {
  return (
    <main className="coming-soon-page">
      <div className="coming-bg bg-top-left" />
      <div className="coming-bg bg-bottom-left" />
      <div className="coming-bg bg-bottom-right" />

      <section className="coming-stage" aria-label="Coming soon">
        <div className="coming-copy">
          <div className="coming-eyebrow">SOMETHING NEW IS</div>

          <h1>
            <span className="word-coming">Coming</span>
            <span className="word-soon">Soon.</span>
          </h1>

          <p>
            We&apos;re building something meaningful for you.
            <br />
            Stay tuned for the next chapter.
          </p>

          <div className="coming-divider" aria-hidden="true">
            <span />
            <i />
            <span />
          </div>

          <a className="coming-home-btn" href="/">
            <span>BACK TO HOME</span>
            <b>→</b>
          </a>
        </div>
      </section>
    </main>
  );
}
